export default __webpack_public_path__ + "static/media/BREW.59d9c34a.png";